import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiStepsLogCreateRequestParams,
	IApiStepsLogCreateRequestBody,
	IApiStepsLogCreateResponseData,

	IApiStepsLogUpdateRequestParams,
	IApiStepsLogUpdateRequestBody,
	IApiStepsLogUpdateResponseData,
} from './types';

export class StepsLogApi extends BaseApi {

	async create(options: IRequestOptions<IApiStepsLogCreateRequestParams, IApiStepsLogCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiStepsLogCreateRequestBody, IApiStepsLogCreateResponseData>({
			url: getParametrizedUrl(URLS_API.STEPS_LOG),
			data: body,
		});
	}

	async update(options: IRequestOptions<IApiStepsLogUpdateRequestParams, IApiStepsLogUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiStepsLogUpdateRequestBody, IApiStepsLogUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.STEPS_LOG_ITEM, params as unknown as Record<string, string>),
			data: body,
		});
	}

}
